import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';

import BackstageApi      from 'app/apis/backstage';
import BackstageLayout   from 'app/components/backstage/layout';
import ModalNewPvs       from 'app/components/backstage/modal-new-pvs-intl';
import ModalPvsUpload    from 'app/components/backstage/modal-pvs-upload';
import history           from 'app/history';
import paths             from 'app/paths';
import RoutingSlx        from 'app/selectors/routing';



const colStyles = {maxWidth: 300, overflow: 'hidden'};

class BackstageNonprofitsPage extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      pvss: null,
      showNewPvsModal: false,
      pvsUpload: null,
    };


    this.onClickNewPvs = this.onClickNewPvs.bind(this);
    this.onCloseNewPvsModal = this.onCloseNewPvsModal.bind(this);
    this.onClosePvsUploadModal = this.onClosePvsUploadModal.bind(this);
  }

  /*
   *  Life Cycle
   */

  componentDidMount() {
    this.fetch();
  }

  componentDidUpdate(prevProps) {
    const isStillOnPage = this.props.path === '/backstage/pvss';
    if ((prevProps.url !== this.props.url) && isStillOnPage) {
      this.fetch();
    }
  }

  /*
   *  Helpers
   */

  pathWithNewParams(newParams = {}) {
    return paths.bsNonprofits({...this.props.query, ...newParams});
  }

  /*
   *  Tasks
   */

  fetch() {
    this.setState({pvss: null});
    BackstageApi.pvssSearch().then(({percentValidationSubmissions: pvss}) => {
      this.setState({pvss});
    });
  }

  updateParams(newParams) {
    const path = this.pathWithNewParams(newParams);
    history.push(path);    
  }

  /*
   *  Event handlers
   */

  onClickNewPvs() {
    this.setState({showNewPvsModal: true});
  }
  onCloseNewPvsModal() {
    this.setState({showNewPvsModal: false});
  }

  onClickShowDocs(pvs) {
    this.setState({pvsUpload: pvs});
  }
  onClosePvsUploadModal() {
    this.setState({pvsUpload: null});
  }

  /*
   *  Render
   */

  renderPvss() {
    const { pvss } = this.state;
    if (!pvss) return 'Loading...';

    return (
      <table className="backstage sticky-header">
        <thead>
          <tr>
            <th>Created</th>
            <th>Updated</th>
            <th>Status</th>
            <th style={colStyles}>Org</th>
            <th>Country</th>
            <th style={colStyles}>Registry</th>
            <th style={colStyles}>IDs</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {pvss.map((pvs) => {
            const name = pvs.percentData?.validationRequest?.name || pvs.millieData.organisationName;
            const website = pvs.percentData?.validationRequest?.website || pvs.millieData.website;
            const country = pvs.percentData?.validationRequest?.countryCode || pvs.millieData.countryCode;
            const registryName = pvs.millieData.registryName;
            const locale = pvs.millieData.language;
            return (
              <tr key={pvs.id}>
                <td>{moment.utc(pvs.createdAt).format('YYYY-MM-DD hh:mma')}</td>
                <td>{moment.utc(pvs.updatedAt).format('YYYY-MM-DD hh:mma')}</td>
                <td>{pvs.status}</td>
                <td style={colStyles}>{name}<br />{website}</td>
                <td>{country}<br />{locale}</td>
                <td style={colStyles}>{registryName}<br />{pvs.registryId}</td>
                <td style={colStyles}>{pvs.id}<br />{pvs.percentId}</td>
                <td>
                  <button className="btn xs blue" onClick={this.onClickShowDocs.bind(this, pvs)}>Docs</button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }

  render() {
    const {pvsUpload, showNewPvsModal} = this.state;
    return (
      <BackstageLayout className="bs-page">
        <div className="_flex _justify-between _align-center _pb-24">
          <h1 className="bs-page-h1">Percent Validation Submissions</h1>
          <button className="btn blue small" onClick={this.onClickNewPvs}>New Validation Submission</button>
        </div>
        {this.renderPvss()}
        {showNewPvsModal && (
          <ModalNewPvs onClose={this.onCloseNewPvsModal} />
        )}
        {!!pvsUpload && (
          <ModalPvsUpload pvs={pvsUpload} onClose={this.onClosePvsUploadModal} />
        )}
      </BackstageLayout>
    );
  }

}

const stateToProps = (state) => ({
  url: RoutingSlx.url(state),
  query: RoutingSlx.query(state),
  path: RoutingSlx.path(state),
  claimed: RoutingSlx.query(state).claimed === 'true',
  hasProfile: RoutingSlx.query(state).hasProfile === 'true',
  disabled: RoutingSlx.query(state).disabled === 'true',
  countryCode: RoutingSlx.query(state).countryCode || null,
  search: RoutingSlx.query(state).search || '',
  buildStatus: RoutingSlx.query(state).buildStatus || null,
  percentClaimed: (() => {
    const strVal = RoutingSlx.query(state).percentClaimed;
    if (strVal === 'true') return true;
    if (strVal === 'false') return false;
    return null;
  })(),
});

const dispatchToProps = (dispatch) => ({
});

export default connect(stateToProps, dispatchToProps)(BackstageNonprofitsPage);
